/**
 * The Tableau de bord, in French, the reference language. Merged into fr.ts;
 * every other language has a dashboard.<lang>.ts with the same keys. The
 * server sends numbers only: each alert and queue is worded here.
 */
export const dashboardFr = {
  "dashboard.greeting": "Bonjour, {name}",
  "dashboard.subtitle": "{date} · Conakry",
  "dashboard.generatedAt": "Chiffres lus à {time} (jusqu'à une minute de décalage).",
  "dashboard.refresh": "Actualiser",
  "dashboard.refreshing": "Actualisation…",
  "dashboard.loading": "Chargement du tableau de bord…",
  "dashboard.loadFailed": "Impossible de charger le tableau de bord.",
  "dashboard.alertsAria": "À traiter maintenant",
  "dashboard.alert.open": "Ouvrir →",
  "dashboard.alert.critical_report_open.tag": "Critique",
  "dashboard.alert.critical_report_open.text": "{count} signalement(s) critique(s) ouvert(s).",
  "dashboard.alert.critical_report_open.review":
    "{count} personne(s) suspendue(s) jusqu'à décision de l'équipe ; première revue à faire avant le {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Revue en retard",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} suspension(s) ont passé leur délai de revue (le plus ancien : {date}). Les personnes restent suspendues jusqu'à votre décision.",
  "dashboard.alert.cases_past_deadline.tag": "Retard",
  "dashboard.alert.cases_past_deadline.text":
    "{count} dossier(s) ont dépassé le délai de première réponse ({hours} h).",
  "dashboard.alert.thin_coverage.tag": "Offre",
  "dashboard.alert.thin_coverage.text":
    "{trade} à {city} : {requests} demandes aujourd'hui pour {pros} pro(s) disponible(s). C'est là qu'il faut recruter.",
  "dashboard.alert.failed_payments.tag": "Paiements",
  "dashboard.alert.failed_payments.text": "{count} paiement(s) Orange Money échoué(s) aujourd'hui.",

  "dashboard.card.demand": "Demandes du jour",
  "dashboard.card.demand.answered": "Répondues en moins de {hours} h",
  "dashboard.card.demand.unanswered": "Sans réponse",
  "dashboard.card.demand.expired": "Expirées",
  "dashboard.card.introductions": "Mises en relation",
  "dashboard.card.introductions.quotes": "Devis envoyés",
  "dashboard.card.introductions.median": "Délai médian de première réponse",
  "dashboard.card.introductions.cancelled": "Annulées avant mise en relation",
  "dashboard.card.pros": "Pros vérifiés",
  "dashboard.card.pros.unit": "actifs",
  "dashboard.card.pros.new": "Nouveaux sur 7 jours",
  "dashboard.card.pros.waiting": "En attente de vérification",
  "dashboard.card.pros.suspended": "Suspendus",
  "dashboard.card.money": "Frais encaissés",
  "dashboard.card.money.failed": "Paiements Orange Money échoués",
  "dashboard.card.money.approvals": "Demandes d'accord en attente",
  "dashboard.card.money.subscriptions": "Abonnements mensuels actifs",

  "dashboard.coverage": "Couverture par métier et commune",
  "dashboard.coverage.empty": "Aucune demande aujourd'hui.",
  "dashboard.coverageFoot":
    "En rouge : moins de la moitié des demandes répondues à temps. C'est là qu'il faut recruter.",
  "dashboard.col.trade": "Métier",
  "dashboard.col.commune": "Commune",
  "dashboard.col.requests": "Demandes",
  "dashboard.col.pros": "Pros dispo.",
  "dashboard.col.answered": "Répondues < {hours} h",

  "dashboard.queues": "Files d'attente",
  "dashboard.noQueues": "Aucune file pour vos rôles.",
  "dashboard.queue.late_cases": "Dossiers en retard",
  "dashboard.queue.open_cases": "Dossiers ouverts",
  "dashboard.queue.open_cases.meta": "{count} non attribué(s)",
  "dashboard.queue.identity_verifications": "Vérifications d'identité",
  "dashboard.queue.identity_verifications.meta": "la plus ancienne attend depuis {age}",
  "dashboard.queue.safety_reports": "Signalements ouverts",
  "dashboard.queue.severity.critical": "{count} critique(s)",
  "dashboard.queue.severity.high": "{count} élevé(s)",
  "dashboard.queue.severity.medium": "{count} moyen(s)",
  "dashboard.queue.severity.low": "{count} faible(s)",
  "dashboard.queue.overdue_suspension_reviews": "Revues de suspension en retard",
  "dashboard.queue.overdue_suspension_reviews.meta": "toujours suspendus jusqu'à décision",
  "dashboard.queue.payment_approvals": "Demandes d'accord",
} as const;

export type DashboardMessageId = keyof typeof dashboardFr;
